export class BoltLayout {
  constructor(el) {
    if (!el) return;
    this.el = el;
    this.init();
  }

  init() {
    //only call the observer if there is a layout with the mask attribute
    if (this.el.hasAttribute('mask')) {
      this.handleMaskObserver(this.el);
    }
  }

  handleMaskObserver(el) {
    const callback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // once this layer is revealed, nudge it to the center of the page
          entry.target.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center',
          });

          // initiate animation
          entry.target.classList.add('is-mask-animating');

          // stop observing this element
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(callback);
    observer.observe(el);
  }
}
